import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-62">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-63">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-cream rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-64">
            <div className="sticky top-0 bg-cream border-b border-sage-light/30 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-65">
              <h3 className="text-xl font-heading font-bold text-forest" data-id="element-66">
                {title}
              </h3>
              <button onClick={onClose} className="text-forest/50 hover:text-forest transition-colors p-1 rounded-full hover:bg-sage-light/30" data-id="element-67">
                <XIcon className="w-5 h-5" data-id="element-68" />
              </button>
            </div>
            <div className="px-6 py-6 text-forest/80 text-sm leading-relaxed space-y-4" data-id="element-69">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-forest text-white/60 py-8 text-center text-sm" data-id="element-70">
        <div className="container mx-auto px-6" data-id="element-71">
          <p data-id="element-72">
            © {new Date().getFullYear()} Perimenopausia: Entiende, Ajusta,
            Mejora. Todos los derechos reservados.
          </p>
          <p className="mt-2 text-xs text-white/40 max-w-2xl mx-auto" data-id="element-73">
            Este producto no sustituye el consejo médico profesional. Consulta
            siempre a tu médico antes de realizar cambios significativos en tu
            dieta o estilo de vida.
          </p>
          <div className="mt-4 flex items-center justify-center gap-6" data-id="element-74">
            <button onClick={() => setShowPrivacy(true)} className="text-white/50 hover:text-gold transition-colors underline underline-offset-2" data-id="element-75">
              Política de Privacidad
            </button>
            <span className="text-white/20" data-id="element-76">|</span>
            <button onClick={() => setShowTerms(true)} className="text-white/50 hover:text-gold transition-colors underline underline-offset-2" data-id="element-77">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-78">
        <p data-id="element-79">
          <strong data-id="element-80">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-81">
          Tu privacidad es importante para nosotros. Esta política describe cómo
          recopilamos, usamos y protegemos tu información personal cuando
          adquieres nuestros productos digitales.
        </p>
        <p data-id="element-82">
          <strong data-id="element-83">Información que recopilamos:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-84">
          <li data-id="element-85">
            Nombre y dirección de correo electrónico proporcionados al momento
            de la compra.
          </li>
          <li data-id="element-86">
            Información de pago procesada de forma segura a través de nuestro
            proveedor de pagos (no almacenamos datos de tarjetas).
          </li>
          <li data-id="element-87">Datos de uso anónimos para mejorar nuestros productos.</li>
        </ul>
        <p data-id="element-88">
          <strong data-id="element-89">Uso de la información:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-90">
          <li data-id="element-91">Entregar el producto digital adquirido.</li>
          <li data-id="element-92">Enviar comunicaciones relacionadas con tu compra.</li>
          <li data-id="element-93">Mejorar nuestros productos y servicios.</li>
        </ul>
        <p data-id="element-94">
          <strong data-id="element-95">Protección de datos:</strong> Utilizamos medidas de seguridad
          estándar de la industria para proteger tu información personal. No
          vendemos ni compartimos tus datos con terceros para fines de
          marketing.
        </p>
        <p data-id="element-96">
          <strong data-id="element-97">Tus derechos:</strong> Puedes solicitar acceso, corrección o
          eliminación de tus datos personales en cualquier momento
          contactándonos por correo electrónico.
        </p>
        <p data-id="element-98">
          <strong data-id="element-99">Cookies:</strong> Nuestro sitio puede utilizar cookies
          esenciales para el funcionamiento del proceso de compra.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-100">
        <p data-id="element-101">
          <strong data-id="element-102">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-103">
          Al adquirir el producto "Perimenopausia: Entiende, Ajusta, Mejora",
          aceptas los siguientes términos y condiciones.
        </p>
        <p data-id="element-104">
          <strong data-id="element-105">Producto digital:</strong> Este es un producto de información
          en formato digital (PDF). Una vez completada la compra, recibirás
          acceso inmediato al material.
        </p>
        <p data-id="element-106">
          <strong data-id="element-107">Uso personal:</strong> El contenido es para uso personal y no
          puede ser redistribuido, revendido, copiado o compartido sin
          autorización expresa.
        </p>
        <p data-id="element-108">
          <strong data-id="element-109">Descargo de responsabilidad médica:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-110">
          <li data-id="element-111">Este producto es de carácter informativo y educativo.</li>
          <li data-id="element-112">
            No sustituye el diagnóstico, tratamiento o consejo de un profesional
            de la salud.
          </li>
          <li data-id="element-113">
            Consulta siempre a tu médico antes de realizar cambios en tu dieta,
            suplementación o estilo de vida.
          </li>
          <li data-id="element-114">Los resultados pueden variar según cada persona.</li>
        </ul>
        <p data-id="element-115">
          <strong data-id="element-116">Política de reembolso:</strong> Debido a la naturaleza digital
          del producto y su entrega inmediata, no se ofrecen reembolsos una vez
          completada la descarga. Si tienes problemas técnicos para acceder al
          material, contáctanos y te ayudaremos.
        </p>
        <p data-id="element-117">
          <strong data-id="element-118">Propiedad intelectual:</strong> Todo el contenido, diseño y
          materiales están protegidos por derechos de autor. Queda prohibida su
          reproducción total o parcial sin consentimiento previo.
        </p>
        <p data-id="element-119">
          <strong data-id="element-120">Modificaciones:</strong> Nos reservamos el derecho de
          actualizar estos términos en cualquier momento. Las modificaciones
          serán efectivas desde su publicación.
        </p>
      </Modal>
    </>;
}